<p-tieredMenu #menu [model]="menuItems" [popup]="true"></p-tieredMenu>
<button
  #button
  class="menuItem"
  [hidden]="visible === false"
  (click)="menu?.toggle($event)"
>
  {{ label }}
</button>
